import type { AxiosResponse } from 'axios';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type * as Transcripts from '@trinity/chat/api/interfaces/transcripts';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

type Props = {
  transcriptId: number;
};

export const useTranscriptionHighlights = (props: Props, options: Options = {}) => {
  const apiClient = useChatApiClient();

  return useQuery({
    queryKey: ['transcript-highlights', props] as const,
    queryFn: ({ queryKey }) => {
      const [, params] = queryKey;

      return apiClient.transcripts.getTranscriptHighlights(params)
        .then(res => res.highlights);
    },
    ...options,
  });
};

type Data = Transcripts.GetTranscriptHighlights.Response['highlights'];
type QK = readonly [string, Props];

type Options = Omit<UseQueryOptions<Data, AxiosResponse, Data, QK>, 'queryKey' | 'queryFn'>;